export default "__VITE_ASSET__CD9RaEzD__"